// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1643":"294a497239f0438e","3912":"8358d5f6412d41b6"}[chunkId] + ".css";
};